import { Box, Button, CSS, H1, Text } from '@rcl/rcl';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import windAndSolar from '../../assets/WindAndSolar.png';

const textColor: CSS = { color: '$primaryAuraWhite' };
const image = windAndSolar;
const imageAlt = 'Wind and Solar';

export const ErrorPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const redirectToLoginPage = () => {
    history.push('/login');
  };

  return (
    <main>
      <Box
        css={{
          height: 'calc(100vh - 70px)',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          img: {
            objectFit: 'cover',
            height: '100%',
            width: '100%',
            objectPosition: 'center',
          },
        }}
      >
        <img src={image} alt={imageAlt} />
        <Box
          css={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            background: 'rgba(0,0,0,.3)',
          }}
        >
          <Box
            css={{
              height: '100%',
              display: 'grid',
              alignContent: 'center',
              maxWidth: '500px',
              margin: '-1em auto 0',
              textAlign: 'center',
            }}
          >
            <H1 css={textColor}>401</H1>
            <Text size='$lg' css={textColor}>
              {t('error401text')}
            </Text>

            <Button onClick={redirectToLoginPage} css={{ width: '150px', margin: '20px auto' }}>
              Login
            </Button>
          </Box>
        </Box>
      </Box>
    </main>
  );
};
